export default __webpack_public_path__ + "static/media/ROU.da8b8b05.svg";